import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import CartFooter from '../../common/CartFooter';
import { HiPlus, HiMinus } from 'react-icons/hi';

function CheckProgress() {

    return(
        <>
          <div className="containernn">
             <div className="cart-wrap small">
                <div className="cart-list">
                    <h2 className="title left">My Shopping Cart</h2>
                    <div className="cart-list-group forDesk">
                        <h3>treatments</h3>
                        <div className="table-div">
                        <div className="table-row thead">
                            <div className="table-col head">Name</div>
                            <div className="table-col head">Appointment</div>
                            <div className="table-col head">quantity</div>
                            <div className="table-col head">price</div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/product/lip-filter.png')} /></div>
                                    <span>Lip filler</span>
                                </div>
                            </div>
                            <div className="table-col">
                                <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className="table-col"><span>0.5 ML</span></div>
                            <div className="table-col"><span>£ 27.99</span></div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/product/bum.jpg')} /></div>
                                    <span>Brazilian bum lift consultation</span>
                                </div>
                            </div>
                            <div className="table-col">
                              <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className="table-col"><span>1</span></div>
                            <div className="table-col"><span>£ 34.99</span></div>
                        </div>
                        </div>
                    </div>

                    {/* For Mobile View Only */}
                        <div className="listMob">
                            <h3>treatments</h3>
                            <div className='listMob-group'>
                            <div className="listMob-single">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/product/lip-filter.png')} /></div>
                                    <span>Lip filler</span>
                                </div>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Appointment</span>
                                <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Quantity</span>
                                <span>0.5 ML</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Price</span>
                                <span>£ 34.99</span>
                            </div>
                            </div>
                            <div className='listMob-group'>
                            <div className="listMob-single">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/product/bum.jpg')} /></div>
                                    <span>Brazilian bum lift consultation</span>
                                </div>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Appointment</span>
                                <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Quantity</span>
                                <span>1</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Price</span>
                                <span>£ 34.99</span>
                            </div>
                            </div>
                        </div>
                    {/* For Mobile View Only */}

                    <div className="cart-list-group forDesk">
                        <h3>Products</h3>
                        <div className="table-div for-product">
                        <div className="table-row thead">
                            <div className="table-col head">Name</div>
                            <div className="table-col head">Price per unit</div>
                            <div className="table-col head">Quantity</div>
                            <div className="table-col head">Total Price</div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/pro.png')} /></div>
                                    <span>Aqua lux</span>
                                </div>
                            </div>
                            <div className="table-col"><span>£ 49.00</span></div>
                            <div className="table-col">
                                <span>10</span>
                            </div>
                            <div className="table-col bookLast"><span>£ 49.00</span></div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../../images/pro.png')} /></div>
                                    <span>Aqua premium</span>
                                </div>
                            </div>
                            <div className="table-col"><span>£ 49.00</span></div>
                            <div className="table-col">
                                <span>5</span>
                            </div>
                            <div className="table-col bookLast"><span>£ 49.00</span></div>
                        </div>
                        </div>
                    </div>

                    <div className='listMob'>
                       <h3>Products</h3>
                       <div className='listMob-group'>
                          <div className='listMob-single'>
                            <div className="productName">
                                <div className="productImage"><img alt="" src={require('../../images/pro.png')} /></div>
                                <span>Aqua lux</span>
                            </div>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Price per unit</span>
                            <span>£ 49.00</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Quantity</span>
                            <span>10</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Total Price</span>
                            <span>£ 49.00</span>
                          </div>
                       </div>
                       <div className='listMob-group'>
                          <div className='listMob-single'>
                            <div className="productName">
                                <div className="productImage"><img alt="" src={require('../../images/pro.png')} /></div>
                                <span>Aqua premium</span>
                            </div>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Price per unit</span>
                            <span>£ 49.00</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Quantity</span>
                            <span>10</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Total Price</span>
                            <span>£ 49.00</span>
                          </div>
                       </div>
                    </div>

                </div>
             </div>
          </div>

          <div className="cart-footer">
              <div className="container">
                  <div className="priceButton justify-content-center">
                    <button className="themeBtn line">Cancel</button>
                  </div>
              </div>

              <CartFooter/>

          </div>


        </>
    )
}

export default CheckProgress;